export const POST_MAX_LENGTH_DEFAULT = 280;
export const POST_MAX_LENGTH_VERIFIED = 1000;

export const getPostMaxLength = (isVerified: boolean | undefined): number =>
  isVerified ? POST_MAX_LENGTH_VERIFIED : POST_MAX_LENGTH_DEFAULT;
